import { render, staticRenderFns } from "./CampanhaPieChart.vue?vue&type=template&id=5288b5de&scoped=true&"
import script from "./CampanhaPieChart.vue?vue&type=script&lang=js&"
export * from "./CampanhaPieChart.vue?vue&type=script&lang=js&"
import style0 from "./CampanhaPieChart.vue?vue&type=style&index=0&id=5288b5de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288b5de",
  null
  
)

export default component.exports